import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchIdOffice, selectIdOffice, selectLoading } from "./officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  FormControl,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import SelectMUI from "@material-ui/core/Select";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const OfficeView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdOffice);
  const { id } = useParams();

  const [tableDataUserOffice, setTableDataUserOffice] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await callApi(id);
    }
    fetchMyAPI();
  }, [dispatch, id]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchIdOffice(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Office Profile : {dataId.office_name}
            </CardHeaderTitle>

            <CardHeaderToolbar>
              <Button className="primary" onClick={() => history.goBack()}>
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <div>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Office Name"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.office_code}
                    readOnly
                  />

                  <RedditTextField
                    label="Addres Line 1"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.address1}
                    readOnly
                  />

                  <RedditTextField
                    label="City"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.city}
                    readOnly
                  />
                  <RedditTextField
                    label="Province"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.province}
                    readOnly
                  />
                  <RedditTextField
                    label="Office Type"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.office_type_name}
                    readOnly
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.office_name}
                    readOnly
                  />

                  <RedditTextField
                    label="Addres Line 2"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.address2}
                    readOnly
                  />

                  <RedditTextField
                    label="Zipcode"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.zipcode}
                    readOnly
                  />
                  <RedditTextField
                    label="Country"
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.country_name}
                    readOnly
                  />
                  <div className="border-m">
                    <p className="text-muted">Finansial Year starts on</p>
                    <Row>
                      <Col sm={6}>
                        <Row>
                          <Col sm={8}>
                            {" "}
                            <FormControl
                              fullWidth
                              className={classes.formControl}
                            >
                              <SelectMUI
                                disabled
                                displayEmpty
                                name="finansial_start_day"
                                className={classes.selectEmpty}
                              >
                                <MenuItem>
                                  {dataId.finansial_start_day}
                                </MenuItem>
                              </SelectMUI>
                            </FormControl>
                          </Col>

                          <Col sm={4}>
                            {" "}
                            <p className="mt-3">Day</p>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <Row>
                          <Col sm={8}>
                            {" "}
                            <FormControl
                              fullWidth
                              className={classes.formControl}
                            >
                              <SelectMUI
                                disabled
                                displayEmpty
                                name="finansial_start_month"
                                className={classes.selectEmpty}
                              >
                                <MenuItem>
                                  {dataId.finansial_start_month}
                                </MenuItem>
                              </SelectMUI>
                            </FormControl>
                          </Col>

                          <Col sm={4}>
                            <p className="mt-3">Month</p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              <p className="font-weight-bold  m-3">Contact Person :</p>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="First Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.first_name}
                    readOnly
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Last Name"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.last_name}
                    readOnly
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {dataId.contactpersons === null
                    ? []
                    : dataId.contactpersons.map((item) => {
                        return (
                          <>
                            <Row>
                              <Col>
                                <RedditTextField
                                  label="Select"
                                  className={classes.margin}
                                  //
                                  variant="filled"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  value={item.phone_type}
                                  readOnly
                                />
                              </Col>
                              <Col>
                                <RedditTextField
                                  label="Phone"
                                  className={classes.margin}
                                  //
                                  variant="filled"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  value={item.phone}
                                  readOnly
                                />
                              </Col>
                            </Row>
                          </>
                        );
                      })}
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Email"
                    inputProps={{ maxLength: 128 }}
                    className={classes.margin}
                    //
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    value={dataId.email}
                    readOnly
                  />
                </Col>
              </Row>
            </div>
            <br />
          </CardBody>
        </Card>
      </>
    )
  );
};
